import { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { CssBaseline, ThemeProvider } from '@material-ui/core';
import AppRoot from 'app-root';

import FingerprintService from 'common/services/trackers/fingerprint';

import ErrorBoundary from 'common/components/error-boundary/error-boundary';
import Loading from 'common/components/loading/loading';
import ToastNotificationContainer from 'common/components/toast-notification/toast-notification-container';
import i18n from 'common/config/i18n';
import { useApTheme } from 'common/helpers/hook.theme';
import { useCallOnInit, useCheckParent } from 'common/helpers/hooks';
import { SettingsService } from 'common/services';
import { setCountries } from 'common/store/global';

const AppRootWrapper = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const dispatch = useDispatch();
  const apTheme = useApTheme();

  useCheckParent();

  useCallOnInit(async () => {
    try {
      const countries = await SettingsService.getCountries();
      dispatch(setCountries(countries));
      await FingerprintService.setVisitorId();
    } catch (e) {
      Promise.reject(e);
    } finally {
      setIsLoading(false);
    }
  });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <I18nextProvider i18n={i18n} defaultNS={'translation'}>
      <ThemeProvider theme={apTheme.currentTheme}>
        <CssBaseline />
        <HelmetProvider>
          <ErrorBoundary>
            <ToastNotificationContainer>
              <BrowserRouter>
                <AppRoot />
              </BrowserRouter>
            </ToastNotificationContainer>
          </ErrorBoundary>
        </HelmetProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default AppRootWrapper;
